<app-loader *ngIf="loginCarg"></app-loader>
<div class = "content">
    <div class = "content-header">
        <h3 class = "content-title">Califica el producto</h3>
        <fa-icon [icon]="faX" class="icon-close" (click)="onNo()"></fa-icon>
    </div>
    <div class = "content-body">
        <p>
            ¿Qué te pareció el producto {{ productName }}?
        </p>
        <div class="rating-stars">
            <span *ngFor="let star of [1, 2, 3, 4, 5]" 
                  class="star-container"
                  (mouseenter)="onMouseEnter(star)"
                  (mouseleave)="onMouseLeave()"
                  (click)="setRating(star)">
            
                <!-- Lógica modificada: currentRating siempre tiene prioridad -->
                <fa-icon [icon]="star <= currentRating ? faStar : 
                                 (hoverRating && star <= hoverRating ? faStar : faStarRegular)"
                         [class.filled]="star <= currentRating || 
                                        (hoverRating && star <= hoverRating)"
                         class="star">
                </fa-icon>
            </span>
        </div>
    </div>
    <div class = "content-footer">
        <button class = "rate-product-button" [disabled] = "currentRating == 0" (click) = "rateProduct()">Enviar calificación</button>
    </div>
</div>